import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';
import { FontSizes } from "../../../types/common/types";

export const templateIncidentHistory = document.createElement('template');

templateIncidentHistory.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
       <gz-side-menu menuwidth="400" isOpen id="incidentHistoryPanelSideMenu">
            <div class="side-menu-content">
              <gz-title id="incidentHistoryTitle" class="incident-history-title" fontSize="18"></gz-title>
              <div class="loading-state"><gz-loader rows="15" columns="2"></gz-loader></div>
              <div id="emptyState" class="empty-state">
                <gz-image-repo state="start">
                  <gz-title id="imageRepoTitleEmpty" class="image-repo-title" fontSize='${FontSizes.HEADING_4}' fontWeight="500"></gz-title>
                  <gz-text id="imageRepoTextEmpty" class="image-repo-text" fontSize="13" fontWeight="100"></gz-text>
                  </gz-image-repo>
              </div>
                <div id="errorState" class="error-state">
                <gz-image-repo state="error">
                  <gz-title id="imageRepoTitleError" class="image-repo-title" fontSize='${FontSizes.HEADING_4}' fontWeight="500"></gz-title>
                  <gz-text id="imageRepoTextError" class="image-repo-text" fontSize="13" fontWeight="100"></gz-text>
                  </gz-image-repo>
              </div>
               <div class="loading-state-scroll"><gz-loader rows="1" columns="2"></gz-loader></div>
              <div id="incidentHistoryList" class="incident-history-list"></div>
          </div>
     </gz-side-menu>
  </div>
`;
